import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { TransitionGroup } from "react-transition-group";

const CardGroup = ({ children, className }) => (
    <TransitionGroup className={classNames("portal-card-group", className)}>
        {children}
    </TransitionGroup>
);

CardGroup.propTypes = {
    className: PropTypes.string,
};
CardGroup.defaultProps = {
    className: null,
};

export default CardGroup;
